import { axios } from 'api'

export const addCartItem = async (item: {
  productId: string
  quantity: number
  isAssembled: boolean
  hingeDirection: string | null
}) => {
  const response = await axios.post('/carts', item)
  return response
}
